import React, { useEffect, useRef, useState } from "react";

const features = [
  {
    title: "Discover New Worlds",
    tagline: "Explore trending creators and fresh challenges every day.",
    image: "https://myfavv.live/wp-content/uploads/2026/01/P1.png",
  },
  {
    title: "Create Your Vibe",
    tagline: "Post images, videos, music and express yourself freely.",
    image: "https://myfavv.live/wp-content/uploads/2026/01/P2.png",
  },
  {
    title: "Join the Party",
    tagline: "Participate in live challenges and exciting happenings.",
    image: "https://myfavv.live/wp-content/uploads/2026/01/P3.png",
  },
  {
    title: "Grow With Community",
    tagline: "Connect, collaborate and rise with amazing people.",
    image: "https://myfavv.live/wp-content/uploads/2026/01/P4.png",
  },
];

export default function WelcomePopup({ show, onClose }) {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!show) return;

    timerRef.current = setInterval(() => {
      setIndex((prev) => {
        if (prev === features.length - 1) {
          clearInterval(timerRef.current);
          setTimeout(onClose, 1200);
          return prev;
        }
        return prev + 1;
      });
    }, 3000);

    return () => clearInterval(timerRef.current);
  }, [show]);

  const next = () =>
    setIndex((i) => (i + 1) % features.length);

  const prev = () =>
    setIndex((i) => (i - 1 + features.length) % features.length);

  if (!show) return null;

  return (
    <div className="welcome-overlay">
      <div className="welcome-popup">
        <button className="welcome-close" onClick={onClose}>?</button>

        <button className="nav-btn left" onClick={prev}>?</button>
        <button className="nav-btn right" onClick={next}>?</button>

        <div className="welcome-content">
          <div className="welcome-left">
            <h2>{features[index].title}</h2>
            <p>{features[index].tagline}</p>

            <div className="dots">
              {features.map((_, i) => (
                <span
                  key={i}
                  className={i === index ? "dot active" : "dot"}
                  onClick={() => setIndex(i)}
                />
              ))}
            </div>
          </div>

          <div className="welcome-right">
            <img src={features[index].image} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}